import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedSection() {
  const featured = articles.filter((a) => a.isFeatured).slice(0, 3);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            编辑精选的深度技术文章，助你快速掌握前沿知识
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featured.map((article, idx) => {
            const colors = ['primary', 'accent', 'secondary'];
            const color = colors[idx];
            const tagBgMap: Record<string, string> = {
              primary: 'bg-primary-100 text-primary-700',
              accent: 'bg-accent-100 text-accent-700',
              secondary: 'bg-secondary-100 text-secondary-700',
            };

            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-100/70 rounded-xl border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 overflow-hidden cursor-pointer block"
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={article.title}
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-3 flex-wrap">
                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${tagBgMap[color]}`}>
                      {article.tags[0]}
                    </span>
                    <span className="text-xs text-foreground-400">{article.publishDate}</span>
                  </div>
                  <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-4">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <img
                        src={article.avatar}
                        alt={article.author}
                        className="w-6 h-6 rounded-full object-cover"
                      />
                      <span className="text-xs text-foreground-500">{article.author}</span>
                    </div>
                    <span className="text-xs text-foreground-400 flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-eye-line text-xs"></i>
                      </span>
                      {article.readCount.toLocaleString()}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}